import React, { use } from "react"; 
import { addToCart, changeQuantity } from "./cartSlice";
import displaycart from "./displaycart.module.css"
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

export const DisplayCart = (props) => {
    const navigate = useNavigate("/cart")
    const cart = useSelector(state => state.cart)
    const dispatch = useDispatch()
    const cartArray = []
    let subtotal = 0;
    let emptyCart = <div style={{marginBottom: "5px", margin: "1em 0px 15px 1.97em"}}>
      <h2>Your cart is empty</h2>
    </div>
    useEffect(() => {
      console.log("updated")
  });
    for (let key of cart){
        if (key.quantity > 0){
        subtotal += key.quantity * key.price
  }
}

    const add = (name, quantity) => {
      dispatch(changeQuantity(name, quantity))
    }

 //   }

  /*  Object.entries(cart) // Use Object.entries to get [key, value] pairs
    .filter(([namey, item]) => item.quantity >= 1) // Filter items with quantity >= 1
    .forEach(([namey, item]) => {
      cartArray.push(
        <>
          <hr style={{ margin: "30px 0px" }} />
          <div className={displaycart.itemContainer}>
            <img src={item.image} />
            <div className={displaycart.namePriceContainer}>
              <div>
                <p>{namey}</p>
                <p style={{ textAlign: "center" }}>£{item.price}</p>
              </div>
              <span className={displaycart.quantityContainer}>
                <p
                  style={{
                    scale: "1.3",
                    cursor: "pointer",
                    transform: "translate(0%, -5%)",
                  }}
                  onClick={() => props.dispatch(changeQuantity(namey, -1))}
                >
                  -
                </p>
                <p>{item.quantity}</p>
                <p
                  style={{ cursor: "pointer" }}
                  onClick={() => props.dispatch(changeQuantity(namey, 1))}
                >
                  +
                </p>
              </span>
            </div>
          </div>
        </>
      );
    });
  */ 
    let index = 0;
    // push items to cartArray that have a quantity of one or more
    cart.filter(item => item.quantity >= 1)
    .map(item => {
        cartArray.push(
            <div key={index}>
            <hr style={{ margin: "30px 0px" }} />
            <div className={displaycart.itemContainer}>
              <img src={item.image} />
              <div className={displaycart.nameQuantityContainer}>  {/* Name and quantity container for each item in a row layout */}
                <div className={displaycart.namePriceContainer}>
                  <p>{item.name}</p>
                  <p style={{ textAlign: "center" }} className={displaycart.price}>£{item.price}</p>
                </div>
                <span className={displaycart.quantityContainer}>
                  <p 
                    style={{
                      scale: "1.3",
                      cursor: "pointer",
                      transform: "translate(0%, -4.5%)",
                    }}
                    onClick={() => add(item.name, -1)}
                  >
                    -
                  </p>
                  <p>{item.quantity}</p>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => add(item.name, 1)}
                  >
                    +
                  </p>
                </span>
              </div>
            </div>
          </div>
        )
        index += 1
    })

    
    

    return (
        <div className={displaycart.shoppingContainer}>
            <h1>Shopping Cart</h1>
            {cartArray.length ? (            <div className={displaycart.itemsOrderContainer}> {/* Container for the items list and order summary */}
                <div className={displaycart.itemsContainer}>  {/* Container for the items list */}
                    {cartArray.length ? cartArray : emptyCart}
                </div>

                <div className={displaycart.orderContainer} style={{display: cartArray.length ? "block" : "none"}}>  {/* Order summary Wrapper with background color */}
                  <div className={displaycart.order}> {/* Order sumarry Container */}
                    <h2>Order Summary</h2>
                    <div className={displaycart.orderColumn}><p>Subtotal</p> <p>£{subtotal.toFixed(2)}</p></div>
                    <div className={displaycart.orderColumn}><p>Shipping</p> <p>£{3}</p></div>
                    <div className={displaycart.orderColumn}><p>Tax</p> <p>£{0}</p></div>
                    <div className={`${displaycart.orderColumn} ${displaycart.orderTotal}`}><p>Order Total</p> <p>£{(subtotal + 3).toFixed(2)}</p></div>
                    <button className={displaycart.checkout}>Checkout</button>
                 </div>
                </div>
            </div>) : emptyCart}
        </div>
    )

}